import React from 'react';
import EmployeeSectionWrapper from 'domain/people/employee/shared/EmployeeSectionWrapper';
import BalancesLeavesTypeField from '../field/BalancesLeavesTypeField';
import BalancesLeavesStatusField from '../field/BalancesLeavesStatusField';
import LeaveColumnLayout from '../layout/LeaveColumnLayout';
import LeavesDataGridLayout from '../layout/LeavesDataGridLayout';
import OtherSectionHeader from '../shared/OtherSectionHeader';
import LeavePeriodField from '../field/LeavePeriodField';
import ViewDetailsButton from '../shared/ViewDetailsButton';
import { MappedLeaveItem } from '../../shared/types';
import NumberOfCalendarDaysField from '../field/NumberOfCalendarDaysField';
import { Filter, ListPageLayout, ListWithoutStoringParams, LoadingParams } from 'framework/list';

interface OtherLeavesSectionProps {
  getOtherLeavesDataMethod: (loadParams?: LoadingParams) => Promise<{ result: MappedLeaveItem[] }>;
  defaultFilter?: Filter;
  showAllPeriods?: boolean;
  isPolishContractor?: boolean;
  hideShowDetailsButtons?: boolean;
}

const OtherLeavesSection: React.FC<OtherLeavesSectionProps> = ({
  getOtherLeavesDataMethod,
  defaultFilter,
  isPolishContractor = false,
  hideShowDetailsButtons = false,
}) => {
  return (
    <EmployeeSectionWrapper>
      <ListWithoutStoringParams getDataMethod={getOtherLeavesDataMethod} defaultFilter={defaultFilter}>
        <ListPageLayout header={<OtherSectionHeader isPolishContractor={isPolishContractor} />}>
          <LeavesDataGridLayout>
            <LeaveColumnLayout label="Period">
              <LeavePeriodField />
            </LeaveColumnLayout>
            <LeaveColumnLayout label="Leave type">
              <BalancesLeavesTypeField />
            </LeaveColumnLayout>
            <LeaveColumnLayout label="Duration">
              {(data: MappedLeaveItem): React.ReactNode => <NumberOfCalendarDaysField value={data} />}
            </LeaveColumnLayout>
            <LeaveColumnLayout label="Status">
              <BalancesLeavesStatusField />
            </LeaveColumnLayout>
            <>
              {!hideShowDetailsButtons && (
                <LeaveColumnLayout label="Actions">
                  {(data: MappedLeaveItem): React.ReactNode => (
                    <div>
                      <ViewDetailsButton leaveId={data.id ?? ''} />
                    </div>
                  )}
                </LeaveColumnLayout>
              )}
            </>
          </LeavesDataGridLayout>
        </ListPageLayout>
      </ListWithoutStoringParams>
    </EmployeeSectionWrapper>
  );
};

export default OtherLeavesSection;
